import React, { useEffect, useRef, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as xlsx from "xlsx";
import "react-dropdown/style.css";
import LocationService from "../../Services/LocationService";
import propertyService from "../../Services/PropertyService";
import { showErrorToast } from "../../Constant/Notification";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { getIcons } from "../../Constant/Constant";
import ValidationModal from "./ValidationModal";
import AsteriskStyle from "../../Form/Tooltip/AsteriskStyle";
const AddBulkProperty = () => {
  const [propertyType, setPropertyType] = useState("");
  const [name, setName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const fileInputRef = useRef(null);
  
  const [nameError, setNameError] = useState("");
  const [selectedFile, setSelectedFile]= useState(null)
  const [inputJson, setInputJson] = useState(null);
  const [location, setLocation] = useState({});
  const [plots, setPlots] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [propertyPurchaseDate, setPropertyPurchaseDate] = useState(new Date());
    const [documentCharge, setDocumentCharge] = useState("");
    const [locationLink, setLocationLink] = useState("");
    const [surveyNo, setSurveyNo] = useState("");
const icon = getIcons()
  const [errors, setErrors] = useState({
    propertyType: "",
    name: "",
    location: "",
    plots: "",
  });
  const [loading, setLoading] = useState(false);
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await LocationService.fetchLocation();
        const data = response.data;
        const options = Object.entries(data).map(([key, value]) => ({
          label: key,
          value: value,
        }));
        setLocation(options);
      } catch (error) {
        showErrorToast(error.response.data);

        console.error("Error fetching locations:", error);
      }
    };

    fetchLocation();
  }, []);

  const handleChange = (e) => {
    setSelectedLocation(e.target.value);
    // Check if a valid location is selected
    if (e.target.value) {
      setErrors({ ...errors, location: "" }); // Clear location error if a valid option is chosen
    } else {
      setErrors({ ...errors, location: "Location is required." });
    }
  };

  const handlePropertyPurchaseDate = (e) => {
    setPropertyPurchaseDate(e.target.value);
    if (e.target.value) {
      setErrors({ ...errors, propertyPurchaseDate: "" });
    } else {
      setErrors({
        ...errors,
        propertyPurchaseDate: "Property Purchase Date is required",
      });
    }
  };

  const handleNameChange = (e) => {
    setName(
      e.target.value.charAt(0).toUpperCase() +
        e.target.value.slice(1)
    );
    // Clear any previous error when the user changes the name
    setNameError("");
  };

  const validatePlot = () => {
    let isValidPlot = true;
    const newErrors = {
      plots: "",
    };
    if (inputList.length === 0) {
      newErrors.plots = "At least one plot is required.";
      isValidPlot = false;
    } else {
      // Check for empty plots
      if (inputList.some((plot) => plot.trim() === "")) {
        newErrors.plots = "Please fill in all plot details.";
        isValidPlot = false;
      }
    }
    setErrors(newErrors);
    return isValidPlot;
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      propertyType: "",
      name: "",
      location: "",
      propertyPurchaseDate: "",
    };

    if (!propertyType) {
      newErrors.propertyType = "Property type is required.";
      isValid = false;
    }
    if (!name) {
      newErrors.name = "Name is required.";
      isValid = false;
    }
    if (!selectedLocation) {
      newErrors.location = "Location is required.";
      isValid = false;
    }
    if (!propertyPurchaseDate) {
      newErrors.propertyPurchaseDate = "property Purchase Date is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    const propertyData = {
      type: propertyType,
      name: name,
      location: selectedLocation,
      locationLink: locationLink,
      surveyFee: Number(surveyNo),
      purchaseTime: propertyPurchaseDate,
      documentCharge: Number(documentCharge),
      plots: inputJson, // Use only valid plots
    };

    propertyService
      .createProperty(propertyData)
      .then(async (response) => {
        console.log("Property Added Successfully:", response.data);

        // Clear form after success
        setName("");
        setLocation("");
        setPropertyType("");
        setSelectedLocation("");
        setPropertyPurchaseDate("");
       

        await new Promise((resolve) => setTimeout(resolve, 1000));
        if(userRole === "Admin"){
          navigate("/admin/property", {
            state: { message: "Property Created Successfully" },
          });
        }else if (userRole === "CMO"){
          navigate("/cmo/property", {
            state: { message: "Property Created Successfully" },
          });
        }

      })
      .catch((error) => {
        showErrorToast(error.response.data)
        console.error("There was an error adding the property:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [count, setCount] = useState(0);
  const [inputList, setInputList] = useState([
    { indexValue: "", sqftValue: "", ratePerSqft: "" },
  ]);












  const navigate = useNavigate();
  const handleBack = () => {
    if(userRole === "Admin"){

      navigate("/admin/property");
    }else if (userRole === "CMO"){
      navigate("/cmo/property");

    }
  };

  const handleDocumentChargeChange = (value) => {
    setDocumentCharge(value);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const validFileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];

    if (file && !validFileTypes.includes(file.type)) {
      showErrorToast("Only .xlsx and .csv files are allowed.");
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    if (!file) return;
    setSelectedFile(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = xlsx.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = xlsx.utils.sheet_to_json(sheet);

      if (json.length > 500) {
        showErrorToast("You can upload a maximum of 500 plots only.");
        setSelectedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }

      const plotNumbers = new Set();
      const validationErrors = [];

      json.forEach((item, index) => {
        const row = index + 2; 

        const plotNo = String(item["Plot No"]).trim();
        const sqft = item["Plot Sqft"];
        const rate = String(item["Plot Rate Per Sqft"]).trim();
        const status = item["Plot Status"];
        const guideline = String(item["Guidline Sqft Price"]).trim();

        if (!plotNo || plotNo.length > 10) {
          validationErrors.push({ row, field: "Plot No", message: "Must be max 6 characters" });
        }

        if (plotNumbers.has(plotNo)) {
          validationErrors.push({ row, field: "Plot No", message: "Duplicate Plot No" });
        } else {
          plotNumbers.add(plotNo);
        }

        if (!sqft || isNaN(sqft)) {
          validationErrors.push({ row, field: "Plot Sqft", message: "Must be a number" });
        }

        if (!rate || rate.length > 10 || isNaN(rate)) {
          validationErrors.push({ row, field: "Plot Rate Per Sqft", message: "Max 10 digits" });
        }

        if (!/^\d+(\.\d{1,2})?$/.test(guideline)) {
          validationErrors.push({ row, field: "Guidline Sqft Price", message: "Up to 2 decimal places" });
        }

        if (!status || typeof status !== "string" || !status.trim()) {
          validationErrors.push({ row, field: "Plot Status", message: "Required" });
        }
      });

      if (validationErrors.length > 0) {
        setErrorList(validationErrors);
        setShowModal(true);
        setSelectedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }

      // No errors
      const inputJson = json.map((item, index) => ({
        order: index + 1,
        plotNo: String(item["Plot No"]),
        sqft: parseInt(item["Plot Sqft"]),
        ratePerSqft: parseInt(item["Plot Rate Per Sqft"]),
        guidlineSqftPrice: parseFloat(item["Guidline Sqft Price"]),
        registrationCharge: parseInt(item["Registration Charge"]),
        plotStatus: item["Plot Status"].toUpperCase().trim(),
      }));

      setInputJson(inputJson);
      setShowModal(false);
      setErrorList([]);
      if (fileInputRef.current) fileInputRef.current.value = "";
    };

    reader.readAsArrayBuffer(file);
  };
  
  

    const handleDownloadTemplate = () => {
      const link = document.createElement("a");
      link.href = "/Sample Template for Property.xlsx";
      link.setAttribute("download", "sample-template for property upload.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  return (
    <div className="bg-appGrayBackground pb-10 3xl:h-screen">
      <AdminAppBar />
      <ToastContainer />
      <div className="mt-20 pt-4 px-6">
      <div className="flex justify-between">

        <div className="flex gap-6">
          <svg
            onClick={handleBack}
            className=" cursor-pointer"
            width="20"
            height="34"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>
          <div className="font-semibold md:mx-0 3xl:ml-12 lg:mx-0 md:text-2xl lg:text-4xl">
              Add Property 
            </div>
        </div>

          <div className="">

            <button
              onClick={handleSubmit}
              className="bg-customGreen text-white md:w-28  md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl
          lg:text-2xl font-medium"
              disabled={loading}
            >
              {loading ? (
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white"></div>
                </div>
              ) : (
                "Create Property"
              )}
            </button>
          </div>
        </div>

          <form className="bg-white shadow-md rounded 3xl:w-12/12 3xl:h-[800px] 3xl:ml-12 md:px- 4 lg:px-8 md:px-4 lg:pt-7 md:pt-6 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4 lg:w-full md:w-full">
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor=""
              >
                Property Type <AsteriskStyle/>
              </label>
              <div className="flex w-3/4 relative">
                <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.propertyType ? "border-red-500" : ""
                  }`}
                  // className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="lead-source"
                  name="lead-source"
                  required
                  value={propertyType}
                  onChange={(e) => setPropertyType(e.target.value)}
                  onFocus={() => setErrors({ ...errors, propertyType: "" })}
                >
                  <option value="">Select property type</option>
                  <option value="Layout">Layout</option>
                  <option value="Villa">Villa</option>
                  <option value="Apartment">Apartment</option>
                  <option value="Resale Land">Resale Land</option>
                  <option value="Resale Building">Resale Building</option>
                  <option value="Acres and Cents">Acres and Cents</option>


                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 24 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                      fill="#399E79"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium "
                htmlFor="name"
              >
                Name  <AsteriskStyle/>
              </label>
              <input
                className={`shadow appearance-none border rounded w-3/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.name ? "border-red-500" : ""
                }`}
                id="name"
                type="text"
                maxLength={50}
                placeholder={errors.name || "Enter Property Name"}
                required
                value={name}
                onFocus={() => setErrors({ ...errors, name: "" })}
                onChange={handleNameChange}
                // onChange={(e) => setName(e.target.value.charAt(0).toUpperCase()+ e.target.value.slice(1))}
              />
            </div>
            <div className="mb-8 flex items-center ">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="lead-source"
              >
                Location <AsteriskStyle/>
              </label>

              <div className="flex w-1/4 relative">
                <select
                  id="location"
                  value={selectedLocation}
                  onChange={handleChange}
                  onFocus={() => setErrors({ ...errors, location: "" })}
                  className={`w-full  px-3 py-2 border border-gray-300 text-gray-700 leading-tight focus:outline-none focus:shadow-outline rounded-md ${
                    errors.location ? "border-red-500" : ""
                  }`}
                >
                  <option value="">Select a location</option>
                  {Array.isArray(location) &&
                    location.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              // htmlFor="name"
            >
              Location Link 
            </label>
            <input
              className={`shadow appearance-none border rounded w-1/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline `}
              id="location-link"
              type="text"
              placeholder={errors.locationLink || ""}
              onChange={(e) => setLocationLink(e.target.value)}
            />
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-gray-700 text-2xl font-medium">
              Survey Number
            </label>
            <input
              className={`shadow appearance-none border rounded w-1/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.surveyNo ? "border-red-500" : ""
              }`}
              id="survey-number"
              type="text"
              maxLength={10}
              placeholder={errors.surveyNo || ""}
              required
              value={surveyNo}
              onChange={(e) => {
                let val = e.target.value.replace(/[^0-9.]/g, '');
                if (val.includes('.')) {
                  const [intPart, decPart] = val.split('.');
                  val = intPart + '.' + decPart.slice(0, 2);
                }
                setSurveyNo(val);
              }}
            />
          </div>

            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium "
                // htmlFor="name"
              >
                Property Purchase Date <AsteriskStyle/>
              </label>
              <input
                className={`shadow appearance-none border rounded w-1/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.name ? "border-red-500" : ""
                }`}
                id="Property Purchase Date"
                type="date"
                placeholder={errors.propertyPurchaseDate || ""}
                required
                value={propertyPurchaseDate}
                onFocus={() =>
                  setErrors({ ...errors, propertyPurchaseDate: "" })
                }
                onChange={handlePropertyPurchaseDate}
              />
            </div>

            <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              // htmlFor="name"
            >
              Document Charge
            </label>
            <input
              className={`shadow appearance-none border rounded w-1/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.documentCharge ? "border-red-500" : ""
              }`}
              id="Document Charge"
              type="text"
              maxLength={10}
              placeholder={errors.documentCharge || ""}
              required
              value={documentCharge}
              onChange={(e) => {
                let val = e.target.value.replace(/[^0-9.]/g, '');
                if (val.includes('.')) {
                  const [intPart, decPart] = val.split('.');
                  val = intPart + '.' + decPart.slice(0, 2);
                }
                handleDocumentChargeChange(val);
              }}
              
            />
          </div>

            <div className="mb-8 flex items-center ">
              <label
                className="w-1/4 text-gray-700 text-2xl   font-medium"
                htmlFor="file-upload"
              >
                Attach File
              </label>
              <label className=" w-1/4 ">
                <div className="relative border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer">
                  <span className="absolute inset-y-0 right-3 flex items-center pl-3">
                    <svg
                      className=" md:w-6"
                      width="30"
                      height="30"
                      viewBox="0 0 135 135"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 0H134.449V134.449H0V0Z"
                        fill="white"
                        fill-opacity="0.01"
                      />
                      <path
                        d="M67.2231 123.245H22.4067V11.2036H112.04V67.2242"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M99.4365 123.245V86.8313"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M86.8325 96.6349L91.0341 92.4334L99.4371 84.0303L107.84 92.4334L112.042 96.6349"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M44.8152 44.8159H89.6316"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                      />
                      <path
                        d="M44.8152 67.2241H67.2234"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <span className="pl-0 pr-3 py-1">
                    {selectedFile
                      ? selectedFile.name
                      : "Click here to select a file"}
                  </span>
                  <input
                    id="file-upload"
                    className="absolute inset-0 w-full  opacity-0 cursor-pointer"
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                </div>
              </label>

              <div className="flex gap-5 ml-4">
                {/* <div
                  className="flex flex-col items-center cursor-pointer"
                  // onClick={handleOpenModal}
                >
                  <img src={icon.infoIcon} alt="" className="w-5" />
                  <div>Instruction</div>
                </div> */}

                <div
                  className="flex flex-col items-center cursor-pointer"
                  onClick={handleDownloadTemplate}
                >
                  <img src={icon.downloadIcon} alt="" className="w-5" />
                  <div>Template</div>
                </div>
              </div>
            </div>


          </form>

          <ValidationModal
  show={showModal}
  onClose={() => setShowModal(false)}
  errors={errorList}
/>

      </div>
    </div>
  );
};

export default AddBulkProperty;
